var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCaretDownLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 1.284L1.284 0 7 5.716 12.716 0 14 1.284l-7 7-7-7z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICBkPSJNLTUuNjE0NTdlLTA4IDEuMjg0NDZMMS4yODQ0NiAtNS42MTQ1N2UtMDhMNyA1LjcxNTU0TDEyLjcxNTUgLTUuNjE0NTdlLTA4TDE0IDEuMjg0NDZMNyA4LjI4NDQ2TC01LjYxNDU3ZS0wOCAxLjI4NDQ2WiIgLz4KPC9zdmc+";
export { SvgIconCaretDownLg as ReactComponent };